<div class="tabs">
    <ul class="nav nav-tabs">
        <li *ngFor="let tab of tabList" (click)="changeTab(tab.title)" class="nav-item">
            <a class="nav-link" [class.active]="tab.isActive">{{tab.title}}</a>
        </li>
    </ul>
    <div class="tab-container" [style.maxHeight]="height">
        <ng-content></ng-content>
    </div>
</div>